type PriceWithCurrency = number | null | undefined;

export const formatPrice = (value: number | null, fraction = 0): string => {
  if (!value) {
    return '$0.00';
  }

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: fraction,
  });

  return formatter.format(value);
};

export const formatPriceWithCurrency = (price: PriceWithCurrency, decimals = 2): string => {
  const requiredDecimals = Number.isInteger(price) ? decimals : 2;

  return price ? formatPrice(price, requiredDecimals) : '$ -';
};

export const formatPriceFixed = (value: number | null): string => {
  const formatted = formatPrice(value, 2);
  const fist = formatted[0];
  const remain = formatted.substring(1);

  return `${fist} ${remain}`;
};
